/**
 * RESPONSIBILITY: the flags the FRAMEWORK ships. Apps register their own elsewhere.
 *
 *  ╔══════════════════════════════════════════════════════════════════════════╗
 *  ║  CODES ARE PERMANENT and case-sensitive. Never reuse, never repurpose —  ║
 *  ║  a code is what a shared ?flag= link means.                             ║
 *  ║  Framework: UPPERCASE.   Applications: lowercase and digits.            ║
 *  ╚══════════════════════════════════════════════════════════════════════════╝
 *
 *  Mnemonic where possible: A account, D dev, O outlines, B batch.
 */
import { registerFlag } from './registry';

export const FLAG_ACCOUNT_BAR = registerFlag({
  code: 'A',
  key: 'accountBar',
  label: 'Account bar',
  description:
    'The strip across the top with Sign in / Profile / Admin. Turn it off and the site ' +
    'looks exactly as a visitor sees it — every screen stays reachable by URL ' +
    '(#/login, #/profile, #/admin).',
  // Off by default: a visitor should never see editor chrome. Turn it on with ?flag=A
});

export const FLAG_DEV_BAR = registerFlag({
  code: 'D',
  key: 'devBar',
  label: 'Location inspector',
  description:
    'Bottom bar showing the current route, which section is on screen, which sections ' +
    'are mounted, and the active roles.',
});

export const FLAG_SECTION_OUTLINES = registerFlag({
  code: 'O',
  key: 'sectionOutlines',
  label: 'Outline sections',
  description: 'Draw a labelled dashed border around every section, to see the boundaries.',
});

export const FLAG_BATCH_LOG = registerFlag({
  code: 'B',
  key: 'batchLog',
  label: 'Log batched queries',
  description: 'Print every batched section query to the console with per-section status.',
});
